export default __webpack_public_path__ + "static/media/tag.b0e26399.svg";